import React, { Component } from "react";
import {Router, Route, Switch, HashRouter} from "react-router-dom";
import Home from "./components/Home";
import Signin from "./components/auth/Signin";
import ForgotPassword from "./components/auth/ForgotPassword";
import PinVerification from "./components/auth/PinVerification";
import PinAdd from "./components/auth/PinAdd";
import ForgotPinSignin from "./components/auth/ForgotPinSignin";
import ForgotPin from "./components/auth/ForgotPin";
import Employeelist from "./components/user/Employeelist";
import EmployeeProfile from "./components/user/EmployeeProfile";
import TimeregistrationUserlist from "./components/timeregistration/Userlist";
import UserTimeRegistration from "./components/timeregistration/UserTimeregistration";
// import Timeregistration from "./components/timeregistration/Timeregistration";
import ShiftUserlist from "./components/shift/Userlist";
import ShiftUser from "./components/shift/ShiftUser";
import OpenShift from "./components/shift/OpenShift";
import UserOpenShift from "./components/shift/UserOpenShift";

import FlexUserlist from "./components/FlexSchema/Userlist";
import FlexDetail from "./components/FlexSchema/FlexDetail";

import AbsenceList from "./components/Absence/AbsenceList";
import AbsenceUserList from "./components/Absence/AbsenceUserList";
import AbsenceUser from "./components/Absence/AbsenceUser";
import PublicHoliday from "./components/Absence/PublicHoliday";
import UserAbsenceList from "./components/Absence/UserAbsenceList";

import Chat from "./components/Chat/Chat";
import UserChat from "./components/Chat/UserChat";

//import DeviceList from "./components/Terminal/DeviceList";
import DeviceTimestamp from "./components/Terminal/DeviceTimestamp";

import Home2 from "./components/delete/Home";
import history from "./History";
import About from "./components/About";
import AllPages from "./components/AllPages";
import BillPay from "./components/BillPay";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import Carts from "./components/Carts";
import Components from "./components/Components";
import ComponentsAccordion from "./components/ComponentsAccordion";
import ComponentsAlerts from "./components/ComponentsAlerts";
import ComponentsButtons from "./components/ComponentsButtons";
import ComponentsModals from "./components/ComponentsModals";
import ComponentsNotifications from "./components/ComponentsNotifications";
import ComponentsProgress from "./components/ComponentsProgress";
import ComponentsTabs from "./components/ComponentsTabs";
import ComponentsTable from "./components/ComponentsTable";
import ComponentsTooltip from "./components/ComponentsTooltip";
import Contact from "./components/Contact";
import Notification from "./components/Notification";
import NotificationsList from "./components/notificationsList/notificationsList";

import Saving from "./components/Saving";
import Signup from "./components/Signup";
import Transaction from "./components/Transaction";
import TransactionDetails from "./components/TransactionDetails";
import UserSetting from "./components/UserSetting";

import ProjectList from "./components/Project/ProjectList";
import ProjectDetails from "./components/Project/ProjectDetails";
import ProjectTaskDetail from "./components/Project/ProjectTaskDetail";
import ProjectTaskAdd from "./components/Project/ProjectTaskAdd";

class Routes extends Component {
    render() {
        return (
            <Router history={history}>
                <HashRouter basename="/">
                    <Switch>
                        <Route exact path={'/'} render={(props) => (<Home {...props} />)} />
                        <Route exact path={'/signin'} render={(props) => (<Signin {...props} />)} />
                        <Route exact path={'/forgot-password'} render={(props) => (<ForgotPassword {...props} />)} />
                        <Route exact path={'/pin-verification'} render={(props) => (<PinVerification {...props} />)} />
                        <Route exact path={'/pin-add'} render={(props) => (<PinAdd {...props} />)} />
                        <Route exact path={'/forgot-pin-signin'} render={(props) => (<ForgotPinSignin {...props} />)} />
                        <Route exact path={'/forgot-pin'} render={(props) => (<ForgotPin {...props} />)} />
                        <Route exact path={'/employeelist'} render={(props) => (<Employeelist {...props} />)} />
                        <Route exact path={'/employee-profile/:id'} render={(props) => (<EmployeeProfile {...props} />)} />
                        <Route exact path={'/chat'} render={(props) => (<Chat {...props} />)} />
                        <Route exact path={'/chat/:id'} render={(props) => (<UserChat {...props} />)} />
                        <Route exact path={'/timeregistration-userlist'} render={(props) => (<TimeregistrationUserlist {...props} />)} />
                        <Route exact path={'/timeregistration-user/:id'} render={(props) => (<UserTimeRegistration {...props} />)} /> 
                        {/*
                        <Route exact path={'/device_list'} render={(props) => (<DeviceList {...props} />)} />*/}
                        <Route exact path={'/shift-userlist'} render={(props) => (<ShiftUserlist {...props} />)} />
                        <Route exact path={'/shift-user/:id'} render={(props) => (<ShiftUser {...props} />)} />
                        <Route exact path={'/device-timestamp'} render={(props) => (<DeviceTimestamp {...props} />)} />
                        <Route exact path={'/open_shift'} render={(props) => (<OpenShift {...props} />)} />
                        <Route exact path={'/user_open_shift'} render={(props) => (<UserOpenShift {...props} />)} />
                       
                        <Route exact path={'/flex-userlist'} render={(props) => (<FlexUserlist {...props} />)} />
                        <Route exact path={'/flex-detail/:id'} render={(props) => (<FlexDetail {...props} />)} />
                       
                        <Route exact path={'/absence-list'} render={(props) => (<AbsenceList {...props} />)} />
                        <Route exact path={'/absence-userlist/:id'} render={(props) => (<AbsenceUserList {...props} />)} />
                        <Route exact path={'/absence-user/:id'} render={(props) => (<AbsenceUser {...props} />)} />
                        <Route exact path={'/public-holiday'} render={(props) => (<PublicHoliday {...props} />)} />
                        <Route exact path={'/user-absence-list'} render={(props) => (<UserAbsenceList {...props} />)} />

                        <Route exact path={'/home2'} render={(props) => (<Home2 {...props} />)} />
                        <Route exact path={'/transaction'} render={(props) => (<Transaction {...props} />)} />
                        <Route exact path={'/about'} render={(props) => (<About {...props} />)} />
                        <Route exact path={'/all-pages'} render={(props) => (<AllPages {...props} />)} />
                        <Route exact path={'/bill-pay'} render={(props) => (<BillPay {...props} />)} />
                        <Route exact path={'/blog'} render={(props) => (<Blog {...props} />)} />
                        <Route exact path={'/blog-details'} render={(props) => (<BlogDetails {...props} />)} />
                        <Route exact path={'/carts'} render={(props) => (<Carts {...props} />)} />
                        <Route exact path={'/components'} render={(props) => (<Components {...props} />)} />
                        <Route exact path={'/components-accordion'} render={(props) => (<ComponentsAccordion {...props} />)} />
                        <Route exact path={'/components-alerts'} render={(props) => (<ComponentsAlerts {...props} />)} />
                        <Route exact path={'/components-buttons'} render={(props) => (<ComponentsButtons {...props} />)} />
                        <Route exact path={'/components-modal'} render={(props) => (<ComponentsModals {...props} />)} />
                        <Route exact path={'/components-notifications'} render={(props) => (<ComponentsNotifications {...props} />)} />
                        <Route exact path={'/components-progress'} render={(props) => (<ComponentsProgress {...props} />)} />
                        <Route exact path={'/components-tabs'} render={(props) => (<ComponentsTabs {...props} />)} />
                        <Route exact path={'/components-table'} render={(props) => (<ComponentsTable {...props} />)} />
                        <Route exact path={'/components-tooltip'} render={(props) => (<ComponentsTooltip {...props} />)} />
                        <Route exact path={'/signup'} render={(props) => (<Signup {...props} />)} />
                        <Route exact path={'/contact'} render={(props) => (<Contact {...props} />)} />
                        <Route exact path={'/notification'} render={(props) => (<Notification {...props} />)} />
                        <Route exact path={'/notifications'} render={(props) => (<NotificationsList {...props} />)} />
                        <Route exact path={'/saving'} render={(props) => (<Saving {...props} />)} />
                        <Route exact path={'/transaction-details'} render={(props) => (<TransactionDetails {...props} />)} />
                        <Route exact path={'/user-setting'} render={(props) => (<UserSetting {...props} />)} />
                        <Route exact path={'/project-list'} render={(props) => (<ProjectList {...props} />)} />
                        <Route exact path={'/project-details/:id'} render={(props) => (<ProjectDetails {...props} />)} />
                        <Route exact path={'/task-detail/:id'} render={(props) => (<ProjectTaskDetail {...props} />)} />
                        <Route exact path={'/task-add/:id'} render={(props) => (<ProjectTaskAdd {...props} />)} />
                    </Switch>
                </HashRouter>
            </Router>
        )
    }
}

export default Routes;
